import get from 'lodash/get';
import { createSelector } from 'reselect';
import { selectOneProduct } from '../../selectors';
export const selectHasClaims = createSelector(selectOneProduct, product => get(product, 'claims') !== undefined);
export const selectClaimsData = createSelector(selectOneProduct, product => get(product, 'claims'));
export const selectSmdData = createSelector(selectOneProduct, product => get(product, 'payload.smd', ''));
export const selectSmdFileInfos = createSelector(selectOneProduct, product => get(product, 'smd'));